import { useI18n, usePortfolioData } from "../i18n";
import React, { useEffect } from "react";
import { Helmet } from "react-helmet";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faGithub, faLinkedin } from "@fortawesome/free-brands-svg-icons";

import { faBlog } from "@fortawesome/free-solid-svg-icons";

import Footer from "../components/common/footer";
import NavBar from "../components/common/navBar";
import PortfolioCard from "../components/common/portfolioCard";
import CustomCard from "../components/homepage/customCard";
import ProjectSummary from "../components/experience/projectSummary";

import styles from "./styles/homepage.module.css";

const HOME_EXPERIENCE_IDS = [
  "song-ku-hae-hyeon",
  "if-kakao-mfe",
  "module-federation-blog",
  "nextjs-rendering",
];

const Homepage = () => {
  const {
    user: INFO,
    seo: SEO,
    experiences: EXPERIENCES,
    works: WORKS,
    educations: EDUCATIONS,
    contributions: CONTRIBUTIONS,
  } = usePortfolioData();
  const { t } = useI18n();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const currentSEO = SEO.find((item) => item.page === "home");
  const visibleExperiences = HOME_EXPERIENCE_IDS.map((id) =>
    EXPERIENCES.find((experience) => experience.id === id),
  ).filter(Boolean);

  return (
    <React.Fragment>
      <Helmet>
        <title>{INFO.main.title}</title>
        <meta name="description" content={currentSEO.description} />
        <meta name="keywords" content={currentSEO.keywords.join(", ")} />
      </Helmet>

      <div className="page-content">
        <NavBar active="home" />
        <div className="content-wrapper">
          <div className={styles["homepage-container"]}>
            <div className={styles["homepage-first-area"]}>
              <div className={styles["homepage-first-area-left-side"]}>
                <div className="title">{INFO.homepage.title}</div>

                <div className="subtitle">{INFO.homepage.description}</div>
              </div>

              <div className={styles["homepage-first-area-right-side"]}>
                <div className={styles["homepage-image-container"]}>
                  <div className={styles["homepage-image-wrapper"]}>
                    <img
                      src="homepage.jpg"
                      alt={t("portrait")}
                      className="homepage-image"
                    />
                  </div>
                </div>
              </div>
            </div>

            <div className={styles["homepage-socials"]}>
              <a href={INFO.socials.github} target="_blank" rel="noreferrer">
                <FontAwesomeIcon
                  icon={faGithub}
                  className={styles["homepage-social-icon"]}
                />
              </a>
              <a href={INFO.socials.blog} target="_blank" rel="noreferrer">
                <FontAwesomeIcon
                  icon={faBlog}
                  className={styles["homepage-social-icon"]}
                />
              </a>
              <a href={INFO.socials.linkedin} target="_blank" rel="noreferrer">
                <FontAwesomeIcon
                  icon={faLinkedin}
                  className={styles["homepage-social-icon"]}
                />
              </a>
            </div>

            <div className={styles["homepage-projects"]}>
              <ProjectSummary />
            </div>

            <div className={styles["homepage-after-title"]}>
              <div className={styles["homepage-experiences"]}>
                {visibleExperiences.map((experience) => (
                  <div key={experience.id}>
                    <PortfolioCard item={experience} variant="compact" />
                  </div>
                ))}
              </div>

              <div className={styles["homepage-cards"]}>
                <CustomCard type={"work"} arr={WORKS} />
                <CustomCard type={"contribution"} arr={CONTRIBUTIONS} />
                <CustomCard type={"education"} arr={EDUCATIONS} />
              </div>
            </div>

            <div className="page-footer">
              <Footer />
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default Homepage;
